import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'content-blocks'
const verb = 'get'

export default class OspreyContentBlocksSearchSuggestion extends BaseAction {
    constructor(dataKey) {
        const id = '70c90973-600b-496f-83e1-c0fb7ab3c75a'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getSearchSuggestion(params) {
        this.params = Object.assign({
            fields: 'id,name',
            sf: 'name',
            sd: 'asc',
        }, params)

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/content-blocks/content-blocks-search-suggestion.js